var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidByPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0703125 19.9437V21.9453C0.0703125 23.6 4.23031 24.9453 9.35775 24.9453C14.4852 24.9453 18.6452 23.6 18.6452 21.9453V19.9437C16.6474 21.3078 12.9953 21.9453 9.35775 21.9453C5.72017 21.9453 2.06808 21.3078 0.0703125 19.9437ZM15.5494 6.94531C20.6768 6.94531 24.8368 5.6 24.8368 3.94531C24.8368 2.29063 20.6768 0.945312 15.5494 0.945312C10.4219 0.945312 6.26194 2.29063 6.26194 3.94531C6.26194 5.6 10.4219 6.94531 15.5494 6.94531ZM0.0703125 15.0266V17.4453C0.0703125 19.1 4.23031 20.4453 9.35775 20.4453C14.4852 20.4453 18.6452 19.1 18.6452 17.4453V15.0266C16.6474 16.6203 12.9905 17.4453 9.35775 17.4453C5.72501 17.4453 2.06808 16.6203 0.0703125 15.0266ZM20.1931 15.5422C22.9648 15.0219 24.8368 14.0562 24.8368 12.9453V10.9438C23.7146 11.7125 22.0651 12.2375 20.1931 12.5609V15.5422ZM9.35775 8.44531C4.23031 8.44531 0.0703125 10.1234 0.0703125 12.1953C0.0703125 14.2672 4.23031 15.9453 9.35775 15.9453C14.4852 15.9453 18.6452 14.2672 18.6452 12.1953C18.6452 10.1234 14.4852 8.44531 9.35775 8.44531ZM19.9658 11.0844C22.8681 10.5781 24.8368 9.58438 24.8368 8.44531V6.44375C23.1196 7.62031 20.1689 8.25313 17.0634 8.40313C18.4904 9.07344 19.5401 9.97344 19.9658 11.0844Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidByPoints);
export default __webpack_public_path__ + "static/media/paid-by-points.a914f009d2a591bef0173533463f5f1b.svg";
export { ForwardRef as ReactComponent };